import React from 'react';
import toast, { Toaster } from 'react-hot-toast';

import {confirmAlert} from "react-confirm-alert";
import Role from "../../inc/Role";
import {NavLink, useNavigate} from "react-router-dom";
import * as Icon from "react-bootstrap-icons";
import {Config} from '../../Config'
import moment from "moment-timezone";
import * as Utils from "../../inc/Utils";
import Select from 'react-select'
import DatePicker from "react-datepicker";
import {getOwnerRunningId} from "../../inc/Utils";
import {getOwnerRunningCode} from "../../inc/Utils";

export default function GeneratePromotionMultiple() {
    const roles = new Role();
    let userId = roles.loginUserId;

    let btnTextDefault = 'บันทึกข้อมูล';
    let btnTextLoading = 'กำลังบันทึก..';
    let [isLoading, setLoading] = React.useState(false);
    let [buttonText, setButtonText] = React.useState(btnTextDefault);
    const navigate = useNavigate();

    let [lang, setLanguage] = React.useState(null);
    let [langId, setLanguageId] = React.useState(null);
    let [campaignType, setCampaignType] = React.useState(null);
    let [campaignTypeId, setCampaignTypeId] = React.useState(null);
    let [buType, setBuType] = React.useState(null);
    let [buTypeId, setBuTypeId] = React.useState(null);
    let [campaignDate, setCampaignDate] = React.useState(null);
    let [campaign, setCampaign] = React.useState(null);
    let [campaignId, setCampaignId] = React.useState(null);
    let [agency, setAgency] = React.useState(null);
    let [agencyId, setAgencyId] = React.useState(null);
    let [platform, setPlatform] = React.useState(null);
    let [platformId, setPlatformId] = React.useState(null);

    let [campaignPlaceholder, setCampaignPlaceholder] = React.useState('...');
    let [disableCampaign, setDisableCampaign] = React.useState(true);
    let [disableTemplate, setDisableTemplate] = React.useState(true);

    let [campaignTemplate, setCampaignTemplate] = React.useState(null);
    let [campaignTemplateId, setCampaignTemplateId] = React.useState(null);

    let [generateTypeCampaign, setGenerateTypeCampaign] = React.useState(false);
    let [generateTypeAdsSet, setGenerateTypeAdsSet] = React.useState(false);
    let [generateTypeUTM, setGenerateTypeUTM] = React.useState(false);

    let refUrl = React.useRef();

    React.useEffect(() => {
        (async function() {
            try {
                setGenerateTypeCampaign(true);

                setDisableTemplate(true);
                const resTemplate = await Utils.getCampaignTemplate(Utils.GENERATE_TYPE_PROMOTION);
                setCampaignTemplate(resTemplate);
                setDisableTemplate(false);

                const resPlatform = await Utils.getPlatformAll();
                setPlatform(resPlatform);

                const resLanguage = await Utils.getLanguage();
                setLanguage(resLanguage);

                const resCampaignType = await Utils.getCampaignType();
                setCampaignType(resCampaignType);

                const resBuType = await Utils.getBuType();
                setBuType(resBuType);

                const resAgency = await Utils.getAgencySlug();
                let newAgencies = [];
                if(resAgency) {
                    let newA = resAgency.find(e => e.id === roles.agencyId).items;
                    let ownerIds = [];
                    for(let a of newA) {
                        ownerIds.push(a.ownerId);
                    }
                    for(let ag of resAgency) {
                        if(ag.items.find(e => ownerIds.includes(e.ownerId))) {
                            newAgencies.push({
                                id: ag.id,
                                slug: ag.slug,
                                name: ag.name
                            })
                        }
                    }
                }
                if(roles.permissionId !== Utils.SUPER_ADMIN_ID && roles.agencyId) {
                    newAgencies = newAgencies.filter(e => e.id === roles.agencyId);
                }
                setAgency(newAgencies);

                //-- Campaign
                await campaignDetail();

                //-- AdsSet
                await adssetDetail();

                //-- UTM
                await utmDetail();

            } catch (e) {
                toast.error(e.message);
            }
        })();
    }, []);

    const onCreate = async () => {
        let campaignParam = [];
        let generateTypeCampaignValidate = {};
        if(generateTypeCampaign && generateGroupCampaign.length > 0) {
            for(let n=0;n<generateGroupCampaign.length;n++) {
                let param = await getCampaignParams(n);
                let selectedAgency = document.getElementsByName('selectAgencyCampaign['+n+']');
                if(param.params.length > 200) {
                    generateTypeCampaignValidate.message = 'Campaign Parameters [' + generateGroupCampaign[n].name + '] ขนาดตัวอักษรต้องไม่เกิน 200';
                    break;
                }
                else if(!param.success) {
                    generateTypeCampaignValidate.message = 'กรุณาเลือก Campaign Parameters [' + generateGroupCampaign[n].name + '] ให้ครบถ้วน';
                    break;
                }
                else if(!selectedAgency || selectedAgency && !selectedAgency[0].value) {
                    generateTypeCampaignValidate.message = 'Campaign Parameters [' + generateGroupCampaign[n].name + '] กรุณาระบุ Agency';
                    break;
                }
                else {
                    campaignParam[n] = param;
                }
            }
        }

        let adssetParams = [];
        let generateTypeAdsSetValidate = {};
        if (generateTypeAdsSet && generateGroupCampaign.length > 0) {
            for (let n=0;n<generateGroupCampaign.length;n++) {
                adssetParams[n] = [];
                if (generateGroupCampaign[n].masterAdssetItems && generateGroupCampaign[n].masterAdssetItems.length > 0) {
                    for (let idx = 0; idx < generateGroupCampaign[n].masterAdssetItems.length; idx++) {
                        adssetParams[n][idx] = [];
                        const param = await getAdssetParams(n, idx);
                        let selectedSetNameType = document.getElementsByName('selectedAdsNamingSetNameType[' + n + '][' + idx + ']');
                        if (param.params.length > 200) {
                            generateTypeAdsSetValidate.message = 'Ads Set Parameters [' + generateGroupCampaign[n].name + '][ตัวที่ ' + (idx + 1) + '] ขนาดตัวอักษรต้องไม่เกิน 200';
                            break;
                        }
                        else if (!param.success) {
                            generateTypeAdsSetValidate.message = 'กรุณาเลือก Ads Set Parameters [' + generateGroupCampaign[n].name + '][ตัวที่ ' + (idx + 1) + '] ให้ครบถ้วน';
                            break;
                        }
                        else if (!selectedSetNameType || selectedSetNameType && !selectedSetNameType[0].value) {
                            generateTypeAdsSetValidate.message = 'Ads Set Parameters [' + generateGroupCampaign[n].name + '] กรุณาระบุ Type';
                            break;
                        }
                        else {
                            adssetParams[n][idx] = param;
                        }
                    }
                }
            }
        }

        let utmParams = [];
        let generateTypeUTMValidate = {};
        if (generateTypeUTM && generateGroupCampaign.length > 0) {
            setLoading(true);
            setButtonText('กำลังตรวจสอบ UTM...');
            for (let n=0;n<generateGroupCampaign.length;n++) {
                utmParams[n] = [];
                if (generateGroupCampaign[n].masterUtmItems && generateGroupCampaign[n].masterUtmItems.length > 0) {
                    for (let idx = 0; idx < generateGroupCampaign[n].masterUtmItems.length; idx++) {
                        utmParams[n][idx] = [];
                        let sourceTypeIds = [];
                        let selectSourceTypeIds = document.getElementsByName('sourceTypeIds['+n+'][' + idx + '][]');
                        let ownerSelectedId = 0;
                        let ownerSelectedCode = 0;
                        let ownerFullText = '';
                        if (selectSourceTypeIds) {
                            for (let st of selectSourceTypeIds) {
                                if (st.value) {
                                    let utmSourceTypeId = st.value;
                                    let utmSourceId = 0;
                                    let utmSourceTypeText = null;
                                    let inputType = null;

                                    if (utmSourceTypeId.includes(':CID')) {
                                        let sp = utmSourceTypeId.split(':CID');
                                        let contentId = sp[0];
                                        utmSourceId = sp[1];
                                        let contentView = await Utils.getContentIdView(contentId);
                                        utmSourceTypeText = Utils.contentIdGenerater(contentView);
                                        utmSourceTypeId = contentId;
                                        inputType = Utils.API_TYPE_CONTENT_ID;
                                    }
                                    else if (utmSourceTypeId.includes(':OID')) {
                                        let sp = utmSourceTypeId.split(':OID');
                                        let ownerId = sp[0];
                                        utmSourceId = sp[1];
                                        let resOwner = await Utils.getOwnerView(ownerId);
                                        let ownerCodeRow = await getOwnerRunningId(ownerId);
                                        utmSourceTypeText = getOwnerRunningCode(resOwner.code, ownerCodeRow.code ?? 1);
                                        utmSourceTypeId = ownerId;
                                        inputType = Utils.API_TYPE_OWNER_ID;
                                        ownerSelectedId = ownerId;
                                        ownerSelectedCode = ownerCodeRow.code;
                                        ownerFullText = utmSourceTypeText;
                                    }
                                    else if (utmSourceTypeId.includes(':CP')) {
                                        let sp = utmSourceTypeId.split(':CP');
                                        let campaignId = sp[0];
                                        utmSourceId = sp[1];
                                        utmSourceTypeText = campaignId;
                                        utmSourceTypeId = 0;
                                        inputType = Utils.API_TYPE_CAMPAIGN_ID;
                                    }
                                    else if (utmSourceTypeId.includes(':CN')) {
                                        let sp = utmSourceTypeId.split(':CN');
                                        let campaignName = sp[0];
                                        utmSourceId = sp[1];
                                        utmSourceTypeText = campaignName;
                                        utmSourceTypeId = 0;
                                        inputType = Utils.API_TYPE_CAMPAIGN_NAME;
                                    }
                                    else if (utmSourceTypeId.includes(':PJI')) {
                                        let sp = utmSourceTypeId.split(':PJI');
                                        let projectCode = sp[0];
                                        utmSourceId = sp[1];
                                        utmSourceTypeText = projectCode;
                                        utmSourceTypeId = 0;
                                        inputType = Utils.API_TYPE_PROJECT_ID;
                                    }
                                    else if (utmSourceTypeId.includes(':PJN')) {
                                        let sp = utmSourceTypeId.split(':PJN');
                                        let projectName = sp[0];
                                        utmSourceId = sp[1];
                                        utmSourceTypeText = projectName;
                                        utmSourceTypeId = 0;
                                        inputType = Utils.API_TYPE_PROJECT_NAME;
                                    }
                                    else if (utmSourceTypeId.includes(':PJS')) {
                                        let sp = utmSourceTypeId.split(':PJS');
                                        let projectSlug = sp[0];
                                        utmSourceId = sp[1];
                                        utmSourceTypeText = projectSlug;
                                        utmSourceTypeId = 0;
                                        inputType = Utils.API_TYPE_PROJECT_SLUG;
                                    }
                                    else if (utmSourceTypeId.includes(':PMS')) {
                                        let sp = utmSourceTypeId.split(':PMS');
                                        let promotionSlug = sp[0];
                                        utmSourceId = sp[1];
                                        utmSourceTypeText = promotionSlug;
                                        utmSourceTypeId = 0;
                                        inputType = Utils.API_TYPE_PROMOTION_SLUG;
                                    }
                                    else if (utmSourceTypeId.includes(':LINEOA')) {
                                        let sp = utmSourceTypeId.split(':LINEOA');
                                        let lineOAUrl = sp[0];
                                        utmSourceId = sp[1];
                                        utmSourceTypeText = lineOAUrl;
                                        utmSourceTypeId = 0;
                                        inputType = Utils.API_TYPE_LINE_OAID;
                                    }
                                    else {
                                        let sourceTypeRow = await Utils.getUtmSourceTypeById(utmSourceTypeId);
                                        utmSourceId = sourceTypeRow.utmSourceId;
                                        utmSourceTypeText = sourceTypeRow.name;
                                    }

                                    sourceTypeIds.push({
                                        utmSourceId: utmSourceId,
                                        utmSourceTypeId: utmSourceTypeId,
                                        utmSourceTypeText: utmSourceTypeText,
                                        inputType: inputType
                                    });
                                }
                            }
                        }

                        if (sourceTypeIds.length !== selectSourceTypeIds.length) {
                            setLoading(false);
                            setButtonText(btnTextDefault);
                            generateTypeUTMValidate.message = 'กรุณาเลือก UTM [' + generateGroupCampaign[n].name + '][ตัวที่ ' + (idx + 1) + '] ให้ครบถ้วน';
                            break;
                        }
                        else {
                            utmParams[n][idx] = sourceTypeIds;
                        }
                    }
                }
            }
            setLoading(false);
            setButtonText(btnTextDefault);
        }

        let url = refUrl.current.value;

        if(!campaignTemplateId) {
            toast.error("กรุณาระบุ Campaign Template");
        }
        else if(!langId) {
            toast.error("กรุณาระบุ Language");
        }
        else if(!campaignTypeId) {
            toast.error("กรุณาระบุ Campaign Type");
        }
        else if(!buTypeId) {
            toast.error("กรุณาระบุ Bu Type");
        }
        else if(!campaignId) {
            toast.error("กรุณาระบุ Promotion");
        }
        else if(!generateGroupId) {
            toast.error("กรุณาระบุ Group");
        }
        else if(!generateTypeAdsSet) {
            toast.error("ไม่พบข้อมูล Ads Set");
        }
        else if(!generateTypeUTM) {
            toast.error("ไม่พบข้อมูล UTM");
        }
        else if(generateTypeCampaignValidate.message) {
            toast.error(generateTypeCampaignValidate.message);
        }
        else if(generateTypeAdsSetValidate.message) {
            toast.error(generateTypeAdsSetValidate.message);
        }
        else if(generateTypeUTMValidate.message) {
            toast.error(generateTypeUTMValidate.message);
        }
        else if(generateTypeUTM && !url) {
            toast.error("กรุณาระบุ URL");
            refUrl.current.focus();
        }
        else {

            confirmAlert({
                title: 'แจ้งเตือน',
                message: 'ต้องการบันทึกข้อมูล ?',
                buttons: [
                    {
                        label: 'ตกลง',
                        onClick: async() => {
                            setLoading(true);
                            setButtonText(btnTextLoading);

                            let bulkBody = [];
                            if(generateGroupCampaign && generateGroupCampaign.length > 0) {
                                for (let n = 0; n < generateGroupCampaign.length; n++) {
                                    if (generateGroupCampaign[n].masterAdssetItems && generateGroupCampaign[n].masterAdssetItems.length > 0) {
                                        for (let idx = 0; idx < generateGroupCampaign[n].masterAdssetItems.length; idx++) {
                                            let body = {
                                                campaignTemplateId: campaignTemplateId ? campaignTemplateId.id : null,
                                                typeId: Utils.GENERATE_TYPE_PROMOTION,
                                                lang: langId ? langId.id : null,
                                                campaignTypeId: campaignTypeId ? campaignTypeId.id : null,
                                                buTypeId: buTypeId ? buTypeId.id : null,
                                                campaignDate: campaignDate ? new Date(campaignDate) : null,
                                                campaignId: campaignId ? campaignId.campaign_id : null,
                                                agencyId: agencyId ? agencyId.id : null,
                                                adsPlatformId: generateGroupCampaign[n].adsPlatformId,
                                                generateGroupCampaignId: generateGroupCampaign[n].id,
                                                url: url,
                                                createdBy: userId,
                                                createdAt: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
                                                updatedAt: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss')
                                            };

                                            if (generateTypeCampaign) {
                                                body.generateTypeCampaign = 1;
                                                body.paramsCampaign = campaignParam[n].params;
                                                body.campaignSourceTypeIds = campaignParam[n].data;
                                            }
                                            if (generateTypeAdsSet) {
                                                body.generateTypeAdsset = 1;
                                                body.paramsAdsset = adssetParams[n][idx].params;
                                                body.adssetSourceTypeIds = adssetParams[n][idx].data;

                                                let selectedAdsNamingSetNameType = document.getElementsByName('selectedAdsNamingSetNameType['+n+'][' + idx + ']');
                                                let adsNamingSetNameTypeId = null;
                                                if (selectedAdsNamingSetNameType.length > 0) {
                                                    adsNamingSetNameTypeId = selectedAdsNamingSetNameType[0].value;
                                                }
                                                body.adsNamingSetNameTypeId = adsNamingSetNameTypeId;
                                            }
                                            if (generateTypeUTM) {
                                                //Main URL
                                                url = url.toString().trim();

                                                let hashtagText = '';
                                                let selectedHashtag = document.getElementsByName('selectedHashtag['+n+'][' + idx + ']');
                                                if (selectedHashtag.length > 0) {
                                                    hashtagText = selectedHashtag[0].value;
                                                }

                                                //Create Params
                                                let params = await Utils.generateParams(null, null, idx, n);
                                                params = params + (hashtagText ? '#' + hashtagText : '');
                                                let urlParam = url + '?' + params;

                                                //Create Short URL (Rebrandly)
                                                let rebrandlyUrl = null;
                                                if (urlParam && rebrandlyChecked[n]) {
                                                    const resShortUrl = await Utils.getRebrandlyShortURL(rebrandly, urlParam);
                                                    rebrandlyUrl = resShortUrl.shortUrl;
                                                    //rebrandlyUrl = 'rebrandlyUrl-XXX';
                                                }

                                                //Create Short URL (Short.IO)
                                                let shortioUrl = null;
                                                if (urlParam && shortioChecked[n]) {
                                                    const resShortUrl = await Utils.createShortioShortURL(urlParam);
                                                    shortioUrl = resShortUrl.path;
                                                    //shortioUrl = 'shortioUrl-XXX';
                                                }

                                                body.generateTypeUTM = 1;
                                                body.paramsUTM = params;
                                                body.utmTemplateId = utmTemplateId ? utmTemplateId.id : null;
                                                body.utmGroupId = null;
                                                body.utmGroupItemId = null;
                                                body.hashtag = hashtagText ? hashtagText : null;
                                                body.shortUrl = rebrandlyUrl;
                                                body.shortioUrl = shortioUrl;
                                                body.utmSourceTypeIds = utmParams[n][idx];
                                            }

                                            bulkBody.push(body);
                                        }
                                    }
                                }
                            }

                            fetch(Config.url.API_URL +'/api/generate/createBulks', {
                                method: 'POST',
                                body: JSON.stringify(bulkBody),
                                headers: {
                                    'Content-Type':'application/json',
                                    'x-access-token': roles.accessToken
                                }
                            }).then(response => {
                                if(response.ok) {
                                    return response.json();
                                }
                                else {
                                    return response.json().then(err => Promise.reject(err));
                                }
                            }).then(result => {
                                if(result) {
                                    toast.success("บันทึกข้อมูลเรียบร้อย");
                                    setTimeout(function () {
                                        navigate('/generatePromotion', {replace: true});
                                    }, 1500);
                                }
                                else {
                                    setLoading(false);
                                }
                            }).catch(err => {
                                toast.error(err.message);
                            });
                        }
                    },
                    {
                        label: 'ยกเลิก',
                        onClick: () => {
                            setLoading(false);
                            setButtonText(btnTextDefault);
                        }
                    }
                ]
            });
        }
    };

    const onChangeLanguageId = async (obj) => {
        setLanguageId(obj);
        setCampaignTypeId(null);
        setCampaign(null);
        setCampaignId(null);

        setCampaignItemSlugPromotion('');
        setAdssetItemSlugPromotion('');

        if(obj && obj.id && campaignTypeId) {
            await promotionChange(obj.id, campaignTypeId.id, campaignDate);
        }
    };

    const onChangeCampaignTypeId = async (obj) => {
        setCampaignTypeId(obj);
        setCampaign(null);
        setCampaignId(null);

        if(obj && obj.id && langId) {
            await promotionChange(langId.id, obj.id, campaignDate, buTypeId ? buTypeId.id : null);
        }
    };

    const onChangeBuTypeId = async (obj) => {
        setBuTypeId(obj);
        setCampaignPlaceholder('...');
        setCampaign(null);
        setCampaignId(null);

        if(obj && obj.id && langId && campaignTypeId.id) {
            await promotionChange(langId.id, campaignTypeId.id, campaignDate, obj.id);
        }
    };

    const onChangeCampaignDate = async (value) => {
        setCampaignDate(value);
        setCampaign(null);
        setCampaignId(null);
        if(langId && campaignTypeId && value) {
            await promotionChange(langId.id, campaignTypeId.id, new Date(value), buTypeId.id);
        }
    };

    const onChangeCampaignId = async (obj) => {
        setCampaignId(obj);
        await promotionSlug(obj);

        if(generateTypeUTM) {
            setShowUtmListing(false);
            setUtmTemplateId(null);
        }
    };

    //-- Template
    const onChangeCampaignTemplateId =  async (obj) => {
        setCampaignTemplateId(null);
        setLanguageId(null);
        setCampaignTypeId(null);
        setBuTypeId(null);
        setCampaignId(null);
        setAgencyId(null);
        setGenerateGroupId(null);
        refUrl.current.value = '';
        setAgencyId(agency.filter(e => e.id === roles.agencyId)[0]);

        //Set data from template
        if(obj && obj.id) {
            //filter group
            setCampaignTemplateId(obj);
            let templateRow = campaignTemplate.filter(e => e.id === obj.id)[0];
            setLanguageId(lang.filter(e => e.id === templateRow.lang)[0]);
            setCampaignTypeId(campaignType.filter(e => e.id === templateRow.campaignTypeId)[0]);
            setBuTypeId(buType.filter(e => e.id === templateRow.buTypeId)[0]);
            setCampaignDate(templateRow.campaignDate ? new Date(templateRow.campaignDate):'');
            setPlatformId(platform.filter(e => e.id === templateRow.adsPlatformId)[0]);
            refUrl.current.value = templateRow.url ?? '';

            await promotionChange(templateRow.lang, templateRow.campaignTypeId ?? null, templateRow.campaignDate ? new Date(templateRow.campaignDate) : null, templateRow.buTypeId ?? null, null, obj.campaignId);
        }
    };

    const promotionChange = async (langId, campaignTypeId, campaignDate, buTypeId, resView = '', campaignId = '') => {
        setCampaignPlaceholder('กำลังโหลด...');
        const prom = await Utils.getPromotion({
            langId: langId,
            campaignTypeId: campaignTypeId,
            buTypeId: buTypeId,
            campaignDate: campaignDate
        });
        if (typeof prom !== 'undefined' && prom.data) {
            setCampaign(prom.data);
            setCampaignPlaceholder('Select...');
            setDisableCampaign(false);
            if(campaignId) {
                let campaignRow = prom.data.filter(e => e.campaign_id === campaignId)[0];
                setCampaignId(campaignRow);
                await promotionSlug(campaignRow, langId);
            }
        } else {
            setCampaign(null);
            setCampaignPlaceholder('ไม่พบข้อมูล..');
            setDisableCampaign(true);
        }
    };
    const promotionSlug = async (campaignRow, lang = '') => {
        let slug = '';
        if(langId) {
            lang = langId.id;
        }
        if(campaignRow && lang) {
            let buTypeRow = await Utils.getBuTypeView(campaignRow.bu_type);
            let buTypeCondition = buTypeRow.replace;

            if(campaignRow.campaign_type === Utils.CAMPAIGN_TYPE_ALL) {
                slug = lang + '-promotion-' +buTypeCondition + '-' + campaignRow.promotion_slug;
            }
            else if(campaignRow.campaign_type === Utils.CAMPAIGN_TYPE_SPECIAL) {
                slug = lang + '-' +buTypeCondition + '-zone-' + campaignRow.promotion_slug;
            }
        }
        setCampaignItemSlugPromotion(slug);
        setAdssetItemSlugPromotion(slug);
    };

    //region -- Campaign
    let [campaignAdsNaming, setCampaignAdsNaming] = React.useState(null);
    let [campaignExample, setCampaignExample] = React.useState('');
    let [campaignKolPage, setCampaignKolPage] = React.useState('');
    let [campaignPreview, setCampaignPreview] = React.useState([]);
    let [campaignItemSlugPromotion, setCampaignItemSlugPromotion] = React.useState('');
    let [campaignItemFreeForm, setCampaignItemFreeForm] = React.useState('');

    let [generateGroup, setGenerateGroup] = React.useState(null);
    let [generateGroupId, setGenerateGroupId] = React.useState(null);
    let [generateGroupCampaign, setGenerateGroupCampaign] = React.useState(null);
    let [generateLoading, setGenerateGroupLoading] = React.useState(false);

    const campaignDetail = async () => {
        const resGenerateGroup = await Utils.getGenerateGroup();
        if(resGenerateGroup) {
            setGenerateGroup(resGenerateGroup.filter(e => e.typeId === Utils.GENERATE_TYPE_PROMOTION));
        }

        const resAdsNaming = await Utils.getAdsNamingCampaign();
        if(resAdsNaming.length > 0) {
            let ex = [];
            for(let rs of resAdsNaming) {
                if(rs.inputType !== Utils.ADSNAMING_TYPE_SLUG_PROJECT && rs.inputType !== Utils.ADSNAMING_TYPE_SLUG_SPECIAL) {
                    ex.push('{' + rs.name + '}');
                    if(rs.name === 'Objective') {
                        ex.push('{Platform}');
                    }
                }
            }
            setCampaignExample('{Agency}|{BG}|' + ex.join('_') + '_[ST]|{Campaign ID}');

            let newKolPageId = [];
            for(let rs of resAdsNaming) {
                if(rs.inputType === Utils.ADSNAMING_TYPE_KOL_PAGE) {
                    const resKolPage = await Utils.getKol();
                    if(resKolPage) {
                        let campaignKolPageIds = [];
                        for(let row of resKolPage) {
                            let id = row.id;
                            campaignKolPageIds.push({
                                id: id + ':KOL' + rs.id,
                                name:  row.name
                            });
                        }
                        rs.source = campaignKolPageIds;

                        newKolPageId.push({
                            id: rs.id,
                            data: campaignKolPageIds
                        });
                    }
                }
            }
            setCampaignKolPage(newKolPageId);
        }
        setCampaignAdsNaming(resAdsNaming);
    };
    const onCampaignPreview = async (n) => {
        let previewArr = [];
        const param = await getCampaignParams(n);
        previewArr[n] = param.params;
        setCampaignPreview(previewArr);
    };
    async function getCampaignParams(n) {
        let textParams = [];
        let sourceIds = [];
        let kolIds = [];

        //STEP 1 : Find Selected
        let sourceTypeIds = [];
        let sourceTypeAllIds = [];
        let selectSourceTypeIds = document.getElementsByName('sourceTypeIdsCampaign['+n+'][]');
        if(selectSourceTypeIds) {
            for(let st of selectSourceTypeIds) {
                let sourceTypeId = st.value;
                if(sourceTypeId) {
                    //STEP 1.1 : Find special selector
                    if(sourceTypeId.includes(':KOL')) {
                        let sp = sourceTypeId.split(':KOL');
                        let kolId = sp[0];
                        let adsNamingId = sp[1];
                        if(kolId) {
                            campaignKolPage.find(rs => {
                                if(parseInt(rs.id) === parseInt(adsNamingId)) {
                                    let data = rs.data.find(e => {
                                        let id = e.id;
                                        if(id.toString().includes(kolId + ':')) {
                                            return e;
                                        }
                                    });
                                    if(data) {
                                        kolIds.push({
                                            adsNamingSourceId: parseInt(kolId),
                                            adsNamingId: parseInt(adsNamingId),
                                            name: data ? data.name : null,
                                            inputType: Utils.ADSNAMING_TYPE_KOL_PAGE
                                        });
                                    }
                                }
                            });
                        }
                    }
                    else {
                        sourceTypeIds.push(sourceTypeId);
                    }
                    sourceTypeAllIds.push(sourceTypeId);
                }
            }
        }

        //STEP 2 : Get selector type
        if(sourceTypeIds.length > 0) {
            let result = await Utils.getSourceTypeForParam(sourceTypeIds);
            if(result) {
                for(let row of result) {
                    sourceIds.push({
                        adsNamingSourceId: row.id,
                        adsNamingId: row.adsNamingId,
                        name: row.name,
                        inputType: null
                    });
                }
            }
        }

        //STEP 4 : Get for params
        if(campaignAdsNaming.length > 0) {
            campaignAdsNaming.map(async (row, index) => {
                let value = '';
                let inputText = "sourceTypeTextCampaign["+n+"][" + row.id + "]";
                let textSourceTypeIds = document.getElementsByName(inputText);

                if(textSourceTypeIds && textSourceTypeIds[0]) {
                    value = textSourceTypeIds[0].value;
                    textParams.push({
                        adsNamingSourceId: null,
                        adsNamingId: row.id,
                        text: value,
                        inputType: row.inputType
                    });
                }
                else {
                    if(row.inputType === Utils.ADSNAMING_TYPE_KOL_PAGE) {
                        if(kolIds) {
                            let find = kolIds.find(kol => {
                                if(kol.adsNamingId === row.id) {
                                    return kol;
                                }
                            });
                            if(find && find.name) {
                                textParams.push({
                                    adsNamingSourceId: find.adsNamingSourceId,
                                    adsNamingId: row.id,
                                    text: find.name,
                                    inputType: row.inputType
                                });
                            }
                        }
                    }
                    else {
                        let find = sourceIds.find(rs => {
                            if(parseInt(rs.adsNamingId) === parseInt(row.id)) {
                                return rs;
                            }
                        });
                        if(find && find.name) {
                            textParams.push({
                                adsNamingSourceId: find.adsNamingSourceId,
                                adsNamingId: row.id,
                                text: find.name,
                                inputType: null
                            });
                        }

                        if(row.name === 'Objective') {
                            let platformName = '';
                            if(platform && generateGroupCampaign && generateGroupCampaign[n].adsPlatformId) {
                                platformName = platform.filter(e => e.id === generateGroupCampaign[n].adsPlatformId)[0].name;
                                textParams.push({
                                    adsNamingSourceId: null,
                                    adsNamingId: null,
                                    text: platformName,
                                    inputType: null
                                });
                            }
                        }

                        if(row.name === 'Objective') {
                            let platformName = '';
                            if(platform && generateGroupCampaign && generateGroupCampaign[n].adsPlatformId) {
                                platformName = platform.filter(e => e.id === generateGroupCampaign[n].adsPlatformId)[0].name;
                                textParams.push({
                                    adsNamingSourceId: null,
                                    adsNamingId: null,
                                    text: platformName,
                                    inputType: null
                                });
                            }
                        }
                    }
                }
            });
        }

        let agencySlug = '';
        let selectAgencyCampaign = document.getElementsByName('selectAgencyCampaign['+n+']');
        if(selectAgencyCampaign && selectAgencyCampaign[0]) {
            agencySlug = agency.filter(e => e.id === parseInt(selectAgencyCampaign[0].value))[0].slug;
        }

        //Fixed BG
        let bg = textParams.length > 0 ? textParams[0].text:'';

        let params = agencySlug + '|' + bg + '|' + textParams.map(x => x.text).join('_') + '_[ST]|' + (campaignId ? campaignId.campaign_id:'');

        return {
            params: params,
            data: textParams,
            success: sourceTypeAllIds.length === selectSourceTypeIds.length
        };
    }
    const onChangeGenerateGroupId = async (obj) => {
        setGenerateGroupLoading(true);
        setGenerateGroupId(null);
        if(obj && obj.id) {
            setGenerateGroupId(obj);
            const generateGroupList = await Utils.getGenerateGroupCampaign(obj.id);
            if(generateGroupList) {

                setGenerateTypeAdsSet(null);
                setGenerateTypeUTM(null);
                for (let row of generateGroupList) {
                    let sourceTypeSelectedIds = [];
                    if (row.items) {
                        for (let rs of row.items) {
                            let adsNamingSourceId = rs.adsNamingSourceId;
                            if (adsNamingSourceId) {
                                if (rs.inputType === Utils.ADSNAMING_TYPE_KOL_PAGE) {
                                    sourceTypeSelectedIds.push(adsNamingSourceId + ':KOL' + rs.adsNamingId);
                                }
                                else {
                                    sourceTypeSelectedIds.push(adsNamingSourceId);
                                }
                            }
                            else if(rs.inputType === Utils.ADSNAMING_TYPE_FREEFORM) {
                                setCampaignItemFreeForm(row.items.filter(e => e.inputType === Utils.ADSNAMING_TYPE_FREEFORM)[0].text);
                            }
                        }
                    }
                    row.campaignItemSelected = sourceTypeSelectedIds;

                    if(row.master.length > 0) {
                        let checkAssetItem = row.master.filter(e => e.masterAdssetItems);
                        if(checkAssetItem.length > 0) {
                            setGenerateTypeAdsSet(true);
                            row.masterAdssetItems = checkAssetItem;
                        }
                        let checkUtmItem = row.master.filter(e => e.masterUtmItems);
                        if(checkUtmItem.length > 0) {
                            setGenerateTypeUTM(true);
                            row.masterUtmItems = checkUtmItem;
                            for(let row of checkUtmItem) {
                                if(row.utmTemplateId && utmTemplate) {
                                    await onChangeTemplateId(utmTemplate.filter(e => e.id === row.utmTemplateId)[0]);
                                }
                            }
                        }
                    }
                }
                setGenerateGroupCampaign(generateGroupList.filter(e => e.master.length > 0));
            }
            setGenerateGroupLoading(false);
        }
    };
    //endregion

    //region -- Ads Set
    let [adsNamingSetNameType, setAdsNamingSetNameType] = React.useState(null);
    let [adssetAdsNaming, setAdssetAdsNaming] = React.useState(null);
    let [adssetExample, setAdssetExample] = React.useState('');
    let [adssetPreview, setAdssetPreview] = React.useState([]);
    let [adssetItemSlugPromotion, setAdssetItemSlugPromotion] = React.useState('');

    const adssetDetail = async () => {
        const resSetNameType = await Utils.getAdsNamingSetNameType();
        setAdsNamingSetNameType(resSetNameType);

        const resAdssetName = await Utils.getAdsNamingSetName();
        if(resAdssetName.length > 0) {
            let ex = [];
            let ex2 = [];
            let newAdsNaming = [];
            if(resAdssetName) {
                newAdsNaming = resAdssetName.filter(row => row.inputType !== Utils.ADSNAMING_TYPE_SLUG_PROJECT && row.inputType !== Utils.ADSNAMING_TYPE_SLUG_SPECIAL);
                let xLen = newAdsNaming.length;
                if(xLen > 1) {
                    for(let i=0;i<2;i++) {
                        ex.push('{' + newAdsNaming[i].name + '}');
                    }
                }
                if(xLen > 2) {
                    for(let j=2;j<xLen;j++) {
                        ex2.push('{' + newAdsNaming[j].name + '}');
                    }
                }
            }
            setAdssetAdsNaming(newAdsNaming);
            setAdssetExample(ex.join('_') + '|' + ex2.join('_') + '_{Platform}|{Type}_[ST]');
        }
    };
    const onAdssetPreview = async (n) => {
        let previewArr = [[], []];
        if(generateGroupCampaign[n] && generateGroupCampaign[n].masterAdssetItems.length > 0) {
            for(let idx=0;idx<generateGroupCampaign[n].masterAdssetItems.length;idx++) {
                const param = await getAdssetParams(n, idx);
                previewArr[n][idx] = param.params;
            }
        }
        setAdssetPreview(previewArr);
    };
    async function getAdssetParams(n, idx) {
        let textParams = [];
        let textBoxParams = [];
        let sourceIds = [];

        //STEP 1 : Find Selected
        let sourceTypeIds = [];
        let sourceTypeAllIds = [];
        let selectSourceTypeIds = document.getElementsByName('sourceTypeIdsAdsset['+n+'][' + idx + '][]');
        if(selectSourceTypeIds) {
            for(let st of selectSourceTypeIds) {
                let sourceTypeId = st.value;
                if(sourceTypeId) {
                    //STEP 1.1 : Find special selector
                    sourceTypeIds.push(sourceTypeId);
                    sourceTypeAllIds.push(sourceTypeId);
                }
            }
        }

        //STEP 2 : Get selector type
        if(sourceTypeIds.length > 0) {
            let result = await Utils.getSourceTypeForParam(sourceTypeIds);
            if(result) {
                for(let row of result) {
                    sourceIds.push({
                        adsNamingSourceId: row.id,
                        adsNamingId: row.adsNamingId,
                        name: row.name,
                        inputType: null
                    });
                }
            }
        }

        //STEP 4 : Get for params
        if(adssetAdsNaming.length > 0) {
            adssetAdsNaming.map(async (row, index) => {
                let value = '';
                let inputText = "sourceTypeTextAdsset["+n+"][" + idx + "][" + row.id + "]";
                let textSourceTypeIds = document.getElementsByName(inputText);

                if(textSourceTypeIds && textSourceTypeIds[0]) {
                    value = textSourceTypeIds[0].value;
                    textParams.push({
                        adsNamingSourceId: null,
                        adsNamingId: row.id,
                        text: value,
                        inputType: row.inputType
                    });
                    textBoxParams = textParams;
                }
                else {
                    let find = sourceIds.find(rs => {
                        if(parseInt(rs.adsNamingId) === parseInt(row.id)) {
                            return rs;
                        }
                    });
                    if(find && find.name) {
                        textParams.push({
                            adsNamingSourceId: find.adsNamingSourceId,
                            adsNamingId: row.id,
                            text: find.name,
                            inputType: null
                        });
                    }
                }
            });
        }

        //Fixed BG
        let bg = textParams.length > 0 ? textParams[0].text:'';

        //Fixed Slug Promotion
        let slugPromotion = textBoxParams.length > 1 ? textParams[1].text:'';

        //After that
        let textParamsNew = [];
        let showOtherParam = '';
        let xLength = textBoxParams.length;

        if(textBoxParams.length > 2) {
            for(let i=2;i<xLength;i++) {
                if(textBoxParams[i].text.length > 0) {
                    textParamsNew.push({
                        adsNamingSourceId: textBoxParams[i].adsNamingSourceId,
                        adsNamingId: textBoxParams[i].id,
                        text: textBoxParams[i].text,
                        inputType: null
                    });
                }
            }
            showOtherParam = textParamsNew.map(x => x.text).join('_');
        }

        let platformName = '';
        if(platform && generateGroupCampaign && generateGroupCampaign[n].adsPlatformId) {
            platformName = platform.filter(e => e.id === generateGroupCampaign[n].adsPlatformId)[0].name;
            platformName = '_' + platformName;
        }

        let adsNamingSetNameTypeText = '';
        let selectedSetNameType = document.getElementsByName('selectedAdsNamingSetNameType['+n+'][' + idx + ']');
        if(selectedSetNameType && selectedSetNameType.length > 0) {
            let selectedSetNameTypeValue = selectedSetNameType[0].value;
            let adsNamingSetNameTypeRow = adsNamingSetNameType.filter(e => e.id === parseInt(selectedSetNameTypeValue))[0];
            adsNamingSetNameTypeText = adsNamingSetNameTypeRow.name
        }

        let params = bg + '_' + slugPromotion + '|' + showOtherParam + platformName + '|' + adsNamingSetNameTypeText + '_[ST]';

        return {
            params: params,
            data: textParams,
            success: sourceTypeAllIds.length === selectSourceTypeIds.length
        };
    }
    //endregion

    //region -- UTM
    let [utmTemplate, setUtmTemplate] = React.useState(null);
    let [utmTemplateId, setUtmTemplateId] = React.useState(null);
    let [hashtagList, setHashtagList] = React.useState(null);
    let [rebrandly, setRebrandly] = React.useState(null);
    let [shortio, setShortIO] = React.useState(null);
    let [rebrandlyChecked, setRebrandlyChecked] = React.useState(false);
    let [shortioChecked, setShortioChecked] = React.useState(false);
    let [utmPreviewing, setUTMPreviewing] = React.useState(false);
    let [utmPreview, setUTMPreview] = React.useState([]);
    let [utm, setUtm] = React.useState('');
    let [showUTMListing, setShowUtmListing] = React.useState(false);
    let [templateSource, setTemplateSource] = React.useState('');
    let [contentId, setContentId] = React.useState('');
    let [ownerId, setOwnerId] = React.useState('');
    let [userAgency, setUserAgency] = React.useState(null);

    const utmDetail = async () => {
        const resTemplate = await Utils.getTemplate({agencyId: roles.agencyId});
        setUtmTemplate(resTemplate);
        const resRebrandly = await Utils.getRebrandly();
        setRebrandly(resRebrandly);
        const resShortIO = await Utils.getShortIO();
        setShortIO(resShortIO);
        const resHashtag = await Utils.getHashtag();
        setHashtagList(resHashtag);
        const resAgency = await Utils.getAgency({agencyId: roles.agencyId});
        if(resAgency) {
            setUserAgency(resAgency[0]);
        }
    };
    const onUTMPreview = async (n) => {
        setUTMPreviewing(true);
        let previewArr = [[], []];
        if(generateGroupCampaign[n] && generateGroupCampaign[n].masterUtmItems.length > 0) {
            for(let idx=0;idx<generateGroupCampaign[n].masterUtmItems.length;idx++) {
                let params = await Utils.generateParams({langId: langId}, null, idx, n);

                let url = refUrl ? refUrl.current.value : '';

                let hashtagText = '';
                let selectedHashtag = document.getElementsByName('selectedHashtag[' + n + '][' + idx + ']');
                if(selectedHashtag.length > 0) {
                    hashtagText = selectedHashtag[0].value;
                }

                previewArr[n][idx] = (url ? url.toString().trim() + '?':'') + params + (hashtagText ? '#' + hashtagText:'');
            }
        }

        setUTMPreviewing(false);
        setUTMPreview(previewArr);
    };
    const onChangeTemplateId = async (obj) => {
        setShowUtmListing(false);
        setUtmTemplateId(obj);
        setUTMPreview([]);

        if(obj && obj.id) {
            const resSource = await Utils.getTemplateSourceById(obj.id);
            setTemplateSource(resSource);
            const resUtm = await Utils.getUtmByIds(resSource);
            setUtm(resUtm);
            setShowUtmListing(true);

            if(resSource.length > 0) {
                //example
                for(let utm of resUtm) {
                    if(resSource) {
                        let ex = [];
                        for(let rs of resSource) {
                            if(utm.id === rs.utmId) {
                                ex.push('{' + rs.source.name + '}');
                            }
                        }
                        utm.example = ex.join('_');
                    }
                }

                resSource.map( async (rs, idx) => {
                    if(rs.source.inputType === Utils.API_TYPE_CONTENT_ID) {
                        const resContentId = await Utils.getContentId({agencyId: roles.agencyId});
                        let newContentId = [];
                        if(resContentId) {
                            for(let row of resContentId) {
                                newContentId.push({
                                    id: row.id,
                                    xid: row.id + ':CID' + rs.source.id,
                                    name:  Utils.contentIdGenerater(row)
                                });
                            }
                        }
                        setContentId(newContentId);
                    }
                    else if(rs.source.inputType === Utils.API_TYPE_OWNER_ID) {
                        const resOwnerId = await Utils.getOwner({agencyId: roles.agencyId});
                        let newOwnerId = [];
                        if(resOwnerId) {
                            for(let row of resOwnerId) {
                                newOwnerId.push({
                                    id: row.id,
                                    xid: row.id + ':OID' + rs.source.id,
                                    name: row.code.charAt(0) + ' : ' + row.name
                                });
                            }
                        }
                        setOwnerId(newOwnerId);
                    }
                });
            }
        }
    };
    const onShortioChecked = (n, isChecked) => {
        shortioChecked[n] = isChecked;
        setShortioChecked(shortioChecked);
    };
    const ontRebrandlyChecked = (n, isChecked) => {
        rebrandlyChecked[n] = isChecked;
        setRebrandlyChecked(rebrandlyChecked);
    };
    //endregion

    return (

        <main>
            <div className="row table-toolbar mb-2">
                <div className="col-6 align-self-center">
                    <div className="h6 d-inline"><span className="text-success">&#8226;</span> Generate Promotion</div>
                    <span className="ms-1">/</span> <span className="text-muted">Create</span>
                </div>
                <div className="col-6 text-end align-self-center toolbars">
                </div>
            </div>
            <div className="rounded bg-white p-4 shadow">
                <div className="row">
                    <div className="col-12 col-md-5">
                        <form className="row g-3">
                            <div className="col-12">
                                <label htmlFor="langId" className="form-label">Campaign Template <span className="text-danger">*</span></label>
                                <Select
                                    isClearable={true}
                                    isDisabled={disableTemplate}
                                    classNamePrefix="form-select-search"
                                    options={campaignTemplate}
                                    onChange={(event) => onChangeCampaignTemplateId(event)}
                                    value={campaignTemplateId}
                                    getOptionValue={(option) => `${option.id}`}
                                    getOptionLabel={(option) => `${option.name}`}
                                />
                            </div>
                            <div className="col-12">
                                <label htmlFor="url" className="form-label">URL <span className="text-danger">*</span></label>
                                <textarea className="form-control" id="url" ref={refUrl} rows={5} disabled={campaignTemplateId}></textarea>
                            </div>
                            <div className="col-12">
                                <label htmlFor="langId" className="form-label">Language <span className="text-danger">*</span></label>
                                <Select
                                    isDisabled={campaignTemplateId}
                                    classNamePrefix="form-select-search"
                                    options={lang}
                                    onChange={(event) => onChangeLanguageId(event)}
                                    value={langId}
                                    getOptionValue={(option) => `${option.id}`}
                                    getOptionLabel={(option) => `${option.name}`}
                                />
                            </div>
                            <div className="col-12">
                                <label htmlFor="campaignTypeId" className="form-label">Campaign Type <span className="text-danger">*</span></label>
                                <Select
                                    isDisabled={campaignTemplateId || !langId}
                                    classNamePrefix="form-select-search"
                                    options={campaignType}
                                    onChange={(event) => onChangeCampaignTypeId(event)}
                                    value={campaignTypeId}
                                    getOptionValue={(option) => `${option.id}`}
                                    getOptionLabel={(option) => `${option.name}`}
                                />
                            </div>
                            <div className="col-12">
                                <label htmlFor="buTypeId" className="form-label">BU Type <span className="text-danger">*</span></label>
                                <Select
                                    isDisabled={campaignTemplateId || !langId}
                                    classNamePrefix="form-select-search"
                                    options={buType}
                                    onChange={(event) => onChangeBuTypeId(event)}
                                    value={buTypeId}
                                    getOptionValue={(option) => `${option.id}`}
                                    getOptionLabel={(option) => `${option.name}`}
                                />
                            </div>
                            <div className={campaignTypeId ? 'col-12':'d-none'}>
                                <label htmlFor="campaignDate" className="form-label">Campaign Date <span className="text-danger d-none">*</span></label>
                                <DatePicker
                                    selected={campaignDate}
                                    disabled={campaignTemplateId}
                                    onChange={(date) => onChangeCampaignDate(date)}
                                    dateFormat="yyyy-MM-dd"
                                    wrapperClassName="w-100"
                                    className="form-control w-100" />
                            </div>
                            <div className={campaignTypeId ? 'col-12':'d-none'}>
                                <label htmlFor="promotionId" className="form-label">Promotion Title <span className="text-danger">*</span></label>
                                <Select
                                    isDisabled={campaignTemplateId || disableCampaign}
                                    classNamePrefix="form-select-search"
                                    placeholder={campaignPlaceholder}
                                    options={campaign}
                                    onChange={(event) => onChangeCampaignId(event)}
                                    value={campaignId}
                                    getOptionValue={(option) => `${option.promotion_url}`}
                                    getOptionLabel={(option) => `${option.campaign_id} : ${option.promotion_name} : ${option.project_type_slug}`}
                                />
                            </div>
                            <div className="col-12 mt-4">
                                <button type="button" className="btn btn-primary" onClick={onCreate} disabled={isLoading || !generateGroupCampaign || generateGroupCampaign.length === 0}><span
                                    className={isLoading ? 'spinner-grow spinner-grow-sm' : 'd-none'}></span> {buttonText}</button>
                                <NavLink className="btn btn-sm btn-light ms-2" to='/generatePromotion'><span><Icon.ArrowLeft/> กลับไป</span></NavLink>
                                <Toaster position="bottom-right" />
                            </div>
                        </form>
                    </div>
                    <div className="col-12 col-md-7 mt-3 mt-md-0">
                        <form className="row g-3">
                            <div className={"col-12" + (generateTypeCampaign ? '':' d-none')}>
                                <label htmlFor="generateGroupId" className="form-label">Group <span className="text-danger">*</span></label>
                                <Select
                                    classNamePrefix="form-select-search"
                                    options={generateGroup}
                                    onChange={(event) => onChangeGenerateGroupId(event)}
                                    value={generateGroupId}
                                    getOptionValue={(option) => `${option.id}`}
                                    getOptionLabel={(option) => `${option.name}`}
                                />
                            </div>
                        </form>

                        {
                            !generateLoading && generateGroupId && generateGroupCampaign && (generateTypeCampaign || generateTypeAdsSet || generateTypeUTM) ?
                                <>
                                    <ul className="nav nav-tabs mt-3" id="myTabGroup" role="tablist">
                                        {
                                            generateGroupCampaign ?
                                                generateGroupCampaign.map((record, n) => {
                                                    return (
                                                        <li className="nav-item ms-1" role="presentation">
                                                            <button className={"nav-link" + (n === 0 ? ' active':'')} id={"tabGroup-tab" + n } data-bs-toggle="tab"
                                                                    data-bs-target={"#tabGroup" + n} type="button" role="tab" aria-controls={"tabCampaign" + n}
                                                                    aria-selected="true">{record.name}
                                                            </button>
                                                        </li>
                                                    )
                                                }) : ''
                                        }
                                    </ul>

                                    {
                                        generateGroupCampaign ?
                                            generateGroupCampaign.map((record, n) => {
                                                let campaignItemSelected = record.campaignItemSelected;
                                                return (
                                                    <div className="tab-content" id="myTabContent">
                                                        <div className={"tab-pane p-2 fade" + (n === 0 ? ' show active':'')} id={"tabGroup" + n} role="tabpanel" aria-labelledby={"tabGroup-tab" + n}>
                                                            <ul className="nav nav-tabs mt-3" id="myTab" role="tablist">
                                                                {
                                                                    generateTypeCampaign ?
                                                                        <li className="nav-item ms-1" role="presentation">
                                                                            <button className={"nav-link campaign-color active"} id={"tabCampaign-tab" + n} data-bs-toggle="tab" data-bs-target={"#tabCampaign" + n} type="button" role="tab" aria-controls={"tabCampaign" + n} aria-selected="true">Campaign
                                                                            </button>
                                                                        </li> : ''
                                                                }
                                                                {
                                                                    generateTypeAdsSet ?
                                                                        <li className="nav-item ms-1" role="presentation">
                                                                            <button className={"nav-link adsset-color" + (!generateTypeCampaign ? ' active':'')} id={"tabAdsSet-tab" + n} data-bs-toggle="tab" data-bs-target={"#tabAdsSet" + n} type="button" role="tab" aria-controls="profile" aria-selected="false">Ads Set
                                                                            </button>
                                                                        </li> : ''
                                                                }
                                                                {
                                                                    generateTypeUTM ?
                                                                        <li className="nav-item ms-1" role="presentation">
                                                                            <button className={"nav-link utm-color" + (!generateTypeCampaign && !generateTypeAdsSet ? ' active':'')} id={"tabUTM-tab" + n} data-bs-toggle="tab" data-bs-target={"#tabUTM" + n} type="button" role="tab" aria-controls={"tabUTM" + n} aria-selected="false">UTM
                                                                            </button>
                                                                        </li> : ''
                                                                }
                                                            </ul>

                                                            <div className="tab-content" id={"myTabContent" + n}>
                                                                {
                                                                    generateTypeCampaign ?
                                                                        <div className="tab-pane p-2 campaign-bg fade show active" id={"tabCampaign" + n} role="tabpanel" aria-labelledby={"tabCampaign-tab" + n}>
                                                                            <div className="row g-3 p-2">
                                                                                <div className="col-12">
                                                                                    <div className="d-block mb-1 small">{campaignExample}</div>
                                                                                    <label htmlFor="preview" className="form-label"><button type="button" className="btn btn-sm btn-light" onClick={e => onCampaignPreview(n)}>Preview</button></label>
                                                                                </div>

                                                                                <div className="col-12">
                                                                                    <label htmlFor="agency" className="form-label">Agency <span className="text-danger">*</span></label>
                                                                                    <Select
                                                                                        isClearable={false}
                                                                                        classNamePrefix="form-select-search"
                                                                                        name={"selectAgencyCampaign["+n+"]"}
                                                                                        options={agency}
                                                                                        defaultValue={agency ? agency.filter(e => e.id === record.agencyId)[0] : agencyId}
                                                                                        getOptionValue={(option) => `${option.id}`}
                                                                                        getOptionLabel={(option) => `${option.slug}`}
                                                                                    />
                                                                                </div>
                                                                                {
                                                                                    campaignAdsNaming === null || campaignAdsNaming.length <= 0 ? (<p>ไม่พบข้อมูล Ads Naming</p>) :
                                                                                        campaignAdsNaming.map((row, index) => {
                                                                                            let inputText = "sourceTypeTextCampaign["+n+"]["+row.id+"]";
                                                                                            let formId = '';
                                                                                            let source = row.source;
                                                                                            let inputType = row.inputType;
                                                                                            let selected = null;
                                                                                            let inputSelect = "sourceTypeIdsCampaign["+n+"][]";

                                                                                            if(inputType === Utils.ADSNAMING_TYPE_SLUG_PROMOTION) {
                                                                                                formId = 'slug-promotion-campaign';
                                                                                                return (
                                                                                                    <div key={index} className="col-12">
                                                                                                        <div className="d-block fw-bold">{row.name} <span className="text-danger">*</span>
                                                                                                            <span className="text-muted small d-block fw-light">all = {'{lang}-promotion-{bu-type-condition}-{promotion-slug}'}</span>
                                                                                                            <span className="text-muted small d-block fw-light">zone = {'{lang}-{bu-type-condition}-zone-{promotion-slug}'}</span>
                                                                                                        </div>
                                                                                                        <div className=" css-b62m3t-container"><input className="form-control" type="text" id={formId} name={inputText} value={campaignItemSlugPromotion} disabled={true} /></div>
                                                                                                    </div>
                                                                                                );
                                                                                            }
                                                                                            else if(inputType === Utils.ADSNAMING_TYPE_SLUG_PROJECT) {
                                                                                                // -- empty
                                                                                            }
                                                                                            else if(inputType === Utils.ADSNAMING_TYPE_SLUG_SPECIAL) {
                                                                                                // -- empty
                                                                                            }
                                                                                            else if(inputType === Utils.ADSNAMING_TYPE_FREEFORM) {
                                                                                                formId = 'freeform';
                                                                                                return (
                                                                                                    <div key={index} className="col-12">
                                                                                                        <div className="d-block fw-bold">{row.name}</div>
                                                                                                        <div className=" css-b62m3t-container"><input className="form-control bg-white" type="text" id={formId} name={inputText} defaultValue={campaignItemFreeForm} onKeyUp={async e => {
                                                                                                            if(e && e.target.value) {
                                                                                                                e.target.value = Utils.utmSlug(e.target.value);
                                                                                                            }
                                                                                                        }} /></div>
                                                                                                    </div>
                                                                                                );
                                                                                            }
                                                                                            else if(inputType === Utils.ADSNAMING_TYPE_KOL_PAGE) {

                                                                                                if(campaignItemSelected) {
                                                                                                    for (let cs of source) {
                                                                                                        let id = cs.id;
                                                                                                        let sp = id.split(':KOL');
                                                                                                        let kol = parseInt(sp[0]) + ':KOL' + parseInt(row.id);
                                                                                                        if (campaignItemSelected.includes(kol)) {
                                                                                                            selected = {id: id, name: cs.name};
                                                                                                            break;
                                                                                                        }
                                                                                                        else {
                                                                                                            selected = source.filter(e => e.name === 'none')[0];
                                                                                                            break;
                                                                                                        }
                                                                                                    }
                                                                                                }
                                                                                                else {
                                                                                                    selected = source.filter(e => e.name === 'none')[0];
                                                                                                }

                                                                                                return (
                                                                                                    <div key={index} className="col-12">
                                                                                                        <div className="d-block fw-bold">{row.name} <span className="text-danger">*</span></div>
                                                                                                        <div className=" css-b62m3t-container">
                                                                                                            <Select
                                                                                                                isClearable={false}
                                                                                                                name={inputSelect}
                                                                                                                classNamePrefix="form-select-search"
                                                                                                                options={source}
                                                                                                                defaultValue={selected}
                                                                                                                getOptionValue={(option) => `${option.id}`}
                                                                                                                getOptionLabel={(option) => `${option.name}`}
                                                                                                            />
                                                                                                        </div>
                                                                                                    </div>
                                                                                                );
                                                                                            }
                                                                                            else {

                                                                                                if(campaignItemSelected) {
                                                                                                    for(let cs of source) {
                                                                                                        let id = cs.id;
                                                                                                        if(campaignItemSelected.includes(id)) {
                                                                                                            selected = {id: id, name: cs.name};
                                                                                                            break;
                                                                                                        }
                                                                                                    }
                                                                                                }

                                                                                                if(row.name !== 'BG' && row.name !== 'AgencyMaster') {
                                                                                                    return (
                                                                                                        <div key={index} className="col-12">
                                                                                                            <div className="d-block fw-bold">{row.name} <span className="text-danger">*</span></div>
                                                                                                            <Select
                                                                                                                isClearable={false}
                                                                                                                name={inputSelect}
                                                                                                                classNamePrefix="form-select-search"
                                                                                                                options={source}
                                                                                                                defaultValue={selected}
                                                                                                                getOptionValue={(option) => `${option.id}`}
                                                                                                                getOptionLabel={(option) => `${option.name}`}
                                                                                                            />
                                                                                                        </div>
                                                                                                    );
                                                                                                }
                                                                                                else {

                                                                                                    if(row.name === 'Agency' || row.name === 'AgencyMaster') {
                                                                                                        if(roles.agencyId && agency) {
                                                                                                            let ag = agency.filter(e => e.id === roles.agencyId)[0];
                                                                                                            selected = source.filter(e => e.name === ag.slug);
                                                                                                        }
                                                                                                    }

                                                                                                    return (
                                                                                                        <div key={index} className="col-12">
                                                                                                            <div className="d-block fw-bold">{row.name} <span className="text-danger">*</span></div>
                                                                                                            <Select
                                                                                                                isClearable={false}
                                                                                                                name={inputSelect}
                                                                                                                classNamePrefix="form-select-search"
                                                                                                                options={source}
                                                                                                                defaultValue={selected}
                                                                                                                getOptionValue={(option) => `${option.id}`}
                                                                                                                getOptionLabel={(option) => `${option.name}`}
                                                                                                            />
                                                                                                        </div>
                                                                                                    );
                                                                                                }
                                                                                            }
                                                                                        })
                                                                                }

                                                                                <div className="col-12 mt-3">
                                                                                    <div className="noselect-url w100 rounded">{campaignPreview ? campaignPreview[n] : ''}</div>
                                                                                    <p className="mt-2 mb-0">ตัวอักษร : {campaignPreview && campaignPreview[n] ? campaignPreview[n].length : ''}</p>
                                                                                </div>
                                                                            </div>
                                                                        </div> : ''
                                                                }
                                                                {
                                                                    generateTypeAdsSet ?
                                                                        <div className={"tab-pane p-2 adsset-bg fade" + (!generateTypeCampaign ? ' show active':'')} id={"tabAdsSet" + n} role="tabpanel" aria-labelledby={"tabAdsSet-tab" + n}>
                                                                            <div className="row g-3 p-2">
                                                                                <div className="col-12">
                                                                                    <div className="d-block mb-1 small">{adssetExample}</div>
                                                                                    <button type="button" className="btn btn-sm btn-light mb-1" onClick={e => onAdssetPreview(n)}>Preview</button>
                                                                                </div>

                                                                                <div className="col-12">
                                                                                    {
                                                                                        record.masterAdssetItems && record.masterAdssetItems.length > 0 ?
                                                                                            record.masterAdssetItems.map((rs, idx) => {
                                                                                                let items = rs.masterAdssetItems;
                                                                                                let adsNamingSetNameTypeSelected = adsNamingSetNameType.filter(e => e.id === rs.adsNamingSetNameTypeId)[0];
                                                                                                let adssetItemFreeForm = items.filter(e => e.inputType === Utils.ADSNAMING_TYPE_FREEFORM)[0]?.text;
                                                                                                return (
                                                                                                    <>
                                                                                                        <div key={idx} className={"row g-3 p-2 pt-0 adsset-bg2" + (idx > 0 ? ' mt-4':' mt-1')}>
                                                                                                            {
                                                                                                                adssetAdsNaming === null || adssetAdsNaming.length <= 0 ? (<p>ไม่พบข้อมูล Ads Naming</p>) :
                                                                                                                    adssetAdsNaming.map((row, index) => {
                                                                                                                        let inputText = "sourceTypeTextAdsset["+n+"]["+idx+"]["+row.id+"]";
                                                                                                                        let formId = '';
                                                                                                                        let source = row.source;
                                                                                                                        let inputType = row.inputType;
                                                                                                                        let selected = null;

                                                                                                                        if(inputType === Utils.ADSNAMING_TYPE_SLUG_PROMOTION) {
                                                                                                                            formId = 'slug-promotion-campaign';
                                                                                                                            return (
                                                                                                                                <div key={index} className="col-12">
                                                                                                                                    <div className="d-block fw-bold">{row.name} <span className="text-danger">*</span>
                                                                                                                                        <span className="text-muted small d-block fw-light">all = {'{lang}-promotion-{bu-type-condition}-{promotion-slug}'}</span>
                                                                                                                                        <span className="text-muted small d-block fw-light">zone = {'{lang}-{bu-type-condition}-zone-{promotion-slug}'}</span>
                                                                                                                                    </div>
                                                                                                                                    <div className=" css-b62m3t-container"><input className="form-control" type="text" id={formId} name={inputText} value={adssetItemSlugPromotion} disabled={true} /></div>
                                                                                                                                </div>
                                                                                                                            );
                                                                                                                        }
                                                                                                                        else if(inputType === Utils.ADSNAMING_TYPE_SLUG_PROJECT) {
                                                                                                                            // -- empty
                                                                                                                        }
                                                                                                                        else if(inputType === Utils.ADSNAMING_TYPE_SLUG_SPECIAL) {
                                                                                                                            // -- empty
                                                                                                                        }
                                                                                                                        else if(inputType === Utils.ADSNAMING_TYPE_FREEFORM) {
                                                                                                                            formId = 'freeform';
                                                                                                                            return (
                                                                                                                                <div key={index} className="col-12">
                                                                                                                                    <div className="d-block fw-bold">{row.name}</div>
                                                                                                                                    <div className=" css-b62m3t-container"><input className="form-control bg-white" type="text" id={formId} name={inputText} defaultValue={adssetItemFreeForm} onKeyUp={async e => {
                                                                                                                                        if(e && e.target.value) {
                                                                                                                                            e.target.value = Utils.utmSlug(e.target.value);
                                                                                                                                        }
                                                                                                                                    }} /></div>
                                                                                                                                </div>
                                                                                                                            );
                                                                                                                        }
                                                                                                                        else {

                                                                                                                            for(let it of items) {
                                                                                                                                let adsNamingSourceId = it.adsNamingSourceId;
                                                                                                                                let filter = source.filter(e => e.id === adsNamingSourceId);
                                                                                                                                if(filter && filter.length > 0) {
                                                                                                                                    selected = {id: filter[0].id, name: filter[0].name};
                                                                                                                                }
                                                                                                                            }

                                                                                                                            let inputSelect = "sourceTypeIdsAdsset["+n+"]["+idx+"][]";
                                                                                                                            if(row.name !== 'BG' && row.name !== 'AgencyMaster') {
                                                                                                                                return (
                                                                                                                                    <div key={index} className="col-12">
                                                                                                                                        <div className="d-block fw-bold">{row.name} <span className="text-danger">*</span></div>
                                                                                                                                        <Select
                                                                                                                                            isClearable={false}
                                                                                                                                            name={inputSelect}
                                                                                                                                            classNamePrefix="form-select-search"
                                                                                                                                            options={source}
                                                                                                                                            defaultValue={selected}
                                                                                                                                            getOptionValue={(option) => `${option.id}`}
                                                                                                                                            getOptionLabel={(option) => `${option.name}`}
                                                                                                                                        />
                                                                                                                                    </div>
                                                                                                                                );
                                                                                                                            }
                                                                                                                            else {

                                                                                                                                return (
                                                                                                                                    <div key={index} className="col-12">
                                                                                                                                        <div className="d-block fw-bold">{row.name} <span className="text-danger">*</span></div>
                                                                                                                                        <Select
                                                                                                                                            isClearable={false}
                                                                                                                                            name={inputSelect}
                                                                                                                                            classNamePrefix="form-select-search"
                                                                                                                                            options={source}
                                                                                                                                            defaultValue={selected}
                                                                                                                                            getOptionValue={(option) => `${option.id}`}
                                                                                                                                            getOptionLabel={(option) => `${option.name}`}
                                                                                                                                        />
                                                                                                                                    </div>
                                                                                                                                );
                                                                                                                            }
                                                                                                                        }
                                                                                                                    })
                                                                                                            }

                                                                                                            <div className="col-12">
                                                                                                                <label htmlFor="adsNamingSetNameType" className="form-label">Type <span className="text-danger">*</span></label>
                                                                                                                <Select
                                                                                                                    isClearable={false}
                                                                                                                    name={"selectedAdsNamingSetNameType["+n+"]["+idx+"]"}
                                                                                                                    classNamePrefix="form-select-search"
                                                                                                                    options={adsNamingSetNameType}
                                                                                                                    defaultValue={adsNamingSetNameTypeSelected}
                                                                                                                    getOptionValue={(option) => `${option.id}`}
                                                                                                                    getOptionLabel={(option) => `${option.name}`}
                                                                                                                />
                                                                                                            </div>

                                                                                                            <div className="col-12 mt-3">
                                                                                                                <label htmlFor="preview" className="form-label">Preview</label>
                                                                                                                <div className="noselect-url w100 rounded">{adssetPreview[n] && adssetPreview[n][idx] ? adssetPreview[n][idx] : ''}</div>
                                                                                                                <p className="mt-2 mb-0">ตัวอักษร : {adssetPreview && adssetPreview[n] && adssetPreview[n][idx] ? adssetPreview[n][idx].length : ''}</p>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    </>
                                                                                                )
                                                                                            }) : ''
                                                                                    }
                                                                                </div>
                                                                            </div>

                                                                        </div> : ''
                                                                }
                                                                {
                                                                    generateTypeUTM ?
                                                                        <div className={"tab-pane p-2 utm-bg fade" + (!generateTypeCampaign && !generateTypeAdsSet ? ' show active':'')} id={"tabUTM" + n} role="tabpanel" aria-labelledby={"tabUTM-tab" + n}>
                                                                            <div className="row g-3 p-2">

                                                                                <div className="col-12">
                                                                                    <button type="button" className="btn btn-sm btn-light" onClick={e => onUTMPreview(n)}>Preview</button>
                                                                                </div>

                                                                                <div className="col-12 mt-4">
                                                                                    {
                                                                                        record.masterUtmItems !== null && record.masterUtmItems.length > 0 ?
                                                                                            record.masterUtmItems.map((rs, idx) => {
                                                                                                let items = rs.masterUtmItems;
                                                                                                let hastagSelected = null;
                                                                                                if(hashtagList && rs.hashtag) {
                                                                                                    hastagSelected = hashtagList.filter(e => e.id === rs.hashtag)[0];
                                                                                                }
                                                                                                return (
                                                                                                    <>
                                                                                                        <div key={idx} className={"row g-3 p-2 pt-0 utm-bg2" + (idx > 0 ? ' mt-4' : ' mt-0')}>
                                                                                                            <div className="col-12">
                                                                                                                <label htmlFor="template" className="form-label">Template <span className="text-danger">*</span></label>
                                                                                                                <Select
                                                                                                                    isClearable={false}
                                                                                                                    isDisabled={true}
                                                                                                                    classNamePrefix="form-select-search"
                                                                                                                    options={utmTemplate}
                                                                                                                    value={utmTemplateId}
                                                                                                                    getOptionValue={(option) => `${option.id}`}
                                                                                                                    getOptionLabel={(option) => `${option.name}`}
                                                                                                                />
                                                                                                            </div>

                                                                                                            <div className={"col-12 " + (utmTemplateId === null ? 'd-none' : '')}>
                                                                                                                {
                                                                                                                    utm.length <= 0 ? '' :
                                                                                                                        utm.map((row, index) => {
                                                                                                                            return (
                                                                                                                                showUTMListing ? <div key={index} className={"border rounded bg-yellow-light p-2" + (index+1 !== utm.length ? ' mb-3' : '')}>
                                                                                                                                    <div className="d-block fw-bold">{(row.utmPrefix === 1 ? 'utm_':'') + row.name.toLowerCase()} <span className="text-danger">*</span></div>
                                                                                                                                    <div className="d-block mb-1 small">{row.example}</div>
                                                                                                                                    {
                                                                                                                                        templateSource.length <= 0 ? (<p>ไม่พบข้อมูล source</p>) :
                                                                                                                                            templateSource.map((rs, index2) => {
                                                                                                                                                if(rs.source && rs.utmId === row.id) {
                                                                                                                                                    let isClearable = true;
                                                                                                                                                    let rsSource = rs.source.sourceType;
                                                                                                                                                    let inputType = rs.source.inputType;
                                                                                                                                                    let selected = null;
                                                                                                                                                    let canBeSelect = false;

                                                                                                                                                    if(inputType === Utils.API_TYPE_CONTENT_ID) {
                                                                                                                                                        if(contentId) {
                                                                                                                                                            rsSource = contentId;
                                                                                                                                                            for(let cs of rsSource) {
                                                                                                                                                                cs.id = cs.xid;
                                                                                                                                                            }
                                                                                                                                                            canBeSelect = true;
                                                                                                                                                        }
                                                                                                                                                    }
                                                                                                                                                    else if(inputType === Utils.API_TYPE_OWNER_ID) {
                                                                                                                                                        if(ownerId) {
                                                                                                                                                            rsSource = ownerId;
                                                                                                                                                            for(let cs of rsSource) {
                                                                                                                                                                cs.id = cs.xid;
                                                                                                                                                            }
                                                                                                                                                            canBeSelect = true;
                                                                                                                                                        }
                                                                                                                                                    }
                                                                                                                                                    else if(inputType === Utils.API_TYPE_CAMPAIGN_ID) {

                                                                                                                                                        if(campaignId) {
                                                                                                                                                            selected = {
                                                                                                                                                                id: campaignId.campaign_id + ':CP' + rs.source.id,
                                                                                                                                                                name: campaignId.campaign_id
                                                                                                                                                            };
                                                                                                                                                            rsSource = selected;
                                                                                                                                                        }
                                                                                                                                                    }
                                                                                                                                                    else if(inputType === Utils.API_TYPE_CAMPAIGN_NAME) {

                                                                                                                                                        if(campaignId) {
                                                                                                                                                            selected = {
                                                                                                                                                                id: campaignId.campaign_name + ':CN' + rs.source.id,
                                                                                                                                                                name: campaignId.campaign_name
                                                                                                                                                            };
                                                                                                                                                            rsSource = selected;
                                                                                                                                                        }
                                                                                                                                                    }
                                                                                                                                                    else if(inputType === Utils.API_TYPE_PROJECT_ID) {
                                                                                                                                                        //--
                                                                                                                                                    }
                                                                                                                                                    else if(inputType === Utils.API_TYPE_PROJECT_NAME) {
                                                                                                                                                        //--
                                                                                                                                                    }
                                                                                                                                                    else if(inputType === Utils.API_TYPE_PROJECT_SLUG) {
                                                                                                                                                        //--
                                                                                                                                                    }
                                                                                                                                                    else if(inputType === Utils.API_TYPE_PROMOTION_SLUG) {

                                                                                                                                                        if(campaignId && campaignId.promotion_slug) {
                                                                                                                                                            selected = {
                                                                                                                                                                id: campaignId.promotion_slug + ':PMS' + rs.source.id,
                                                                                                                                                                name: campaignId.promotion_slug
                                                                                                                                                            };
                                                                                                                                                            rsSource = selected;
                                                                                                                                                        }
                                                                                                                                                    }
                                                                                                                                                    else if(inputType === Utils.API_TYPE_LINE_OAID) {
                                                                                                                                                        //--
                                                                                                                                                    }
                                                                                                                                                    else {
                                                                                                                                                        for(let it of items) {
                                                                                                                                                            let utmSourceTypeId = parseInt(it.utmSourceTypeId);
                                                                                                                                                            let filter = rsSource.filter(e => e.id === utmSourceTypeId);
                                                                                                                                                            if(filter && filter.length > 0) {
                                                                                                                                                                selected = {id: filter[0].id, name: filter[0].name};
                                                                                                                                                            }
                                                                                                                                                        }
                                                                                                                                                        canBeSelect = true;
                                                                                                                                                    }

                                                                                                                                                    let inputSelect = "sourceTypeIds["+n+"]["+idx+"][]";
                                                                                                                                                    return (
                                                                                                                                                        <div key={index2} className="ms-2 mt-3">
                                                                                                                                                            <div className="row mt-2">
                                                                                                                                                                <div className="col-12 col-sm-4 text-end small">
                                                                                                                                                                    {rs.source.name} :
                                                                                                                                                                    {userAgency?.isEncrypt === 1 && rs.source.isEncrypt ? <div><span className="badge bg-secondary small">encrypt</span></div>:''}
                                                                                                                                                                </div>
                                                                                                                                                                <div className="col-12 col-sm-8">
                                                                                                                                            <span className="text-muted small fw-light">{
                                                                                                                                                inputType === Utils.API_TYPE_PROJECT_NAME ?
                                                                                                                                                    '{lang}-{project_type_slug}-{project_slug}' : ''
                                                                                                                                            }</span>
                                                                                                                                                                    <Select
                                                                                                                                                                        isClearable={false}
                                                                                                                                                                        isSearchable={isClearable}
                                                                                                                                                                        name={inputSelect}
                                                                                                                                                                        classNamePrefix="form-select-search"
                                                                                                                                                                        placeholder={rsSource.length ? 'Select...':'...'}
                                                                                                                                                                        defaultValue={selected}
                                                                                                                                                                        options={canBeSelect ? rsSource : [rsSource]}
                                                                                                                                                                        getOptionValue={(option) => `${option.id}`}
                                                                                                                                                                        getOptionLabel={(option) => `${option.name}`}
                                                                                                                                                                    />

                                                                                                                                                                </div>
                                                                                                                                                            </div>
                                                                                                                                                        </div>
                                                                                                                                                    );
                                                                                                                                                }
                                                                                                                                            })
                                                                                                                                    }
                                                                                                                                </div> : ''
                                                                                                                            );
                                                                                                                        })
                                                                                                                }
                                                                                                            </div>

                                                                                                            <div className="col-12">
                                                                                                                <label htmlFor="typeIed" className="form-label">Hashtag (#)</label>
                                                                                                                <Select
                                                                                                                    isClearable={false}
                                                                                                                    name={"selectedHashtag["+n+"]["+idx+"]"}
                                                                                                                    classNamePrefix="form-select-search"
                                                                                                                    options={hashtagList}
                                                                                                                    defaultValue={hastagSelected}
                                                                                                                    getOptionValue={(option) => `${option.name}`}
                                                                                                                    getOptionLabel={(option) => `${option.name}`}
                                                                                                                />
                                                                                                            </div>

                                                                                                            <div className="col-12">
                                                                                                                <label htmlFor="preview" className="form-label">Preview <span
                                                                                                                    className={utmPreviewing ? 'spinner-grow spinner-grow-sm' : 'd-none'}></span></label>
                                                                                                                <div className="noselect-url w100 rounded">{utmPreview && utmPreview[n] ? utmPreview[n][idx] : ''}</div>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    </>
                                                                                                )
                                                                                            }) : ''
                                                                                    }
                                                                                </div>

                                                                                <div className={"col-12" + (roles.isShortLink(Utils.MENU_UTM_GENERATE) && rebrandly && rebrandly.status===1 && rebrandly.apiKey && rebrandly.endpoint ? '':' d-none')}>
                                                                                    <label htmlFor="rebrandlyUrlx" className="form-label">Create Short URL (Rebrandly)</label>
                                                                                    <div className="form-check form-switch">
                                                                                        <input className="form-check-input" type="checkbox" name="rebrandlyUrlChecked" onChange={e => ontRebrandlyChecked(n, e.target.checked)} />
                                                                                        <label className="form-check-label" htmlFor="rebrandlyUrl"></label>
                                                                                    </div>
                                                                                </div>

                                                                                <div className={"col-12" + (roles.isShortLink(Utils.MENU_UTM_GENERATE) && shortio && shortio.status===1 && shortio.apiKey && shortio.endpoint ? '':' d-none')}>
                                                                                    <label htmlFor="shortioUrlx" className="form-label">Create Short URL (Short.IO)</label>
                                                                                    <div className="form-check form-switch">
                                                                                        <input className="form-check-input" type="checkbox" name={'shortioUrlChecked['+n+']'} onChange={e => onShortioChecked(n, e.target.checked)} />
                                                                                        <label className="form-check-label" htmlFor="shortioUrl"></label>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div> : ''
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                            }) : ''
                                    }
                                </> : ''
                        }
                        {
                            generateLoading ? <span className="spinner-grow spinner-grow-sm mt-2"></span> : ''
                        }

                    </div>
                </div>

            </div>
        </main>
    );
} 